var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84251 3.62602L3.36917 9.41935C3.16251 9.63935 2.96251 10.0727 2.92251 10.3727L2.67584 12.5327C2.58917 13.3127 3.14917 13.846 3.92251 13.7127L6.06917 13.346C6.36917 13.2927 6.78917 13.0727 6.99584 12.846L12.4692 7.05268C13.4158 6.05268 13.8425 4.91268 12.3692 3.51935C10.9025 2.13935 9.78917 2.62602 8.84251 3.62602Z",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92969 4.59375C8.21635 6.43375 9.70969 7.84042 11.563 8.02708",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fdb19a7a33306d60b3ad59f8d360a627.svg";
export { ForwardRef as ReactComponent };